

export const templatePopups = [
  {
    id: -3,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp29.webp",
    templateCode: "FAJUNIORSB",
    recommendation: false,
    headerText: "Similar Design Used By School: St. Vincent Pallotti, Indore",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp29.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp29-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp29-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg,  #011C52, #96FF2C)",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, #011C52, #FFB910)",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg,  #5A3DFF #941AFF, #FFEE32 #B1FF33)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp29-3.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp29-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp29-2.webp",
    ],
    url: "https://www.tafssp.com",
  },
  {
    id: -2,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp28.webp",
    templateCode: "FAJUNIORSB",
    recommendation: false,
    headerText:
      "Similar Design Used By School: St. Joseph's Convent School, Qadian",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp28.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp28-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp28-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, #ffffff, #002B53)",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, #ffffff, #002B53)",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, #ffffff, #6344bf)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp28-3.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp28-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp28-2.webp",
    ],
    url: "https://www.tafssp.com",
  },
  // {
  //   id: -1,
  //   imgName:
  //     "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp27.webp",
  //   templateCode: "FAJUNIORSB",
  //   recommendation: false,
  //   headerText: "Similar Design Used By School: Frank Antony Bangalore Junior",
  //   themeImages: [
  //     "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp27.webp",
  //     "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp27-11.webp",
  //     "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp27-12.webp",
  //   ],
  //   colorOptions: [
  //     {
  //       className: "maroon-color",
  //       gradient: "linear-gradient(45deg, #ACFFF5, #637BAA)",
  //     },
  //     {
  //       className: "blue-color",
  //       gradient: "linear-gradient(45deg, #AAC8FF, #354171)",
  //     },
  //     {
  //       className: "green-color",
  //       gradient: "linear-gradient(45deg, #FFD160, #305192)",
  //     },
  //   ],
  //   deviceImages: [
  //     "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp27-3.webp",
  //     "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp27-1.webp",
  //     "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp27-2.webp",
  //   ],
  //   url: "https://www.tafssp.com",
  // },
  {
    id: 0,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp23.webp",
    templateCode: "TAFFS",
    recommendation: true,
    headerText:
      "Similar Design Used By School: The Airforce School, Subroto Park",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp23.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp23-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp23-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(19 84 138), rgb(253 174 53))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(72 104 183), rgb(224 255 162))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(148 35 35), rgb(237 164 38))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp23-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp23-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp23-3.webp",
    ],
    url: "https://www.tafssp.com",
  },
  {
    id: 1,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp8.webp",
    templateCode: "LCSDD",
    recommendation: true,
    headerText: "Similar Design Used By School: Loreto Convent School, Delhi",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp8.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp8-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp8-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(254 204 81), rgb(116 66 198))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(109 62 187), rgb(252 177 49))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(37 119 193), rgb(255, 166, 0))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp8-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp8-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp8-3.webp",
    ],
    url: "",
  },
  {
    id: 2,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp9.webp",
    templateCode: "MGMMB",
    recommendation: false,
    headerText: "Similar Design Used By School: MAR GREGORIOS MEMORIAL, Bokaro",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp9.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp9-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp9-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(47 51 78), rgb(164 24 25))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(79 50 80), rgb(223 146 63))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(47 82 114), rgb(71 168 101))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp9-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp9-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp9-3.webp",
    ],
    url: "https://www.mgmhssbokaro.in",
  },
  {
    id: 3,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp10.webp",
    templateCode: "MDSND",
    recommendation: false,
    headerText: "Similar Design Used By School: Mater Dei School, New Delhi",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp10.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp10-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp10-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(66, 15, 120), rgb(253 184 1))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(238 129 255), rgb(5 65 91))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(120 255 135), rgb(66 15 120))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp10-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp10-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp10-3.webp",
    ],
    url: "https://www.materdeischool.in/",
  },
  {
    id: 4,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp22.webp",
    templateCode: "TPSPS",
    recommendation: false,
    headerText: "Similar Design Used By School: Tagore Public School, Palwal",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp22.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp22-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp22-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(177 69 145), rgb(100 194 243))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(252 157 78), rgb(122 85 170))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(46 74 135), rgb(88 221 154))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp22-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp22-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp22-3.webp",
    ],
    url: "https://tagore.edu.in",
  },
  {
    id: 5,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp7.webp",
    templateCode: "JRSPPSK",
    recommendation: false,
    headerText:
      "Similar Design Used By School: Jai Rani Sabs Public School, Kerala",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp7.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp7-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp7-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(238 133 5), rgb(16 59 99))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(204 251 136), rgb(35 50 85))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(131 195 210), rgb(134 23 23))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp7-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp7-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp7-3.webp",
    ],
    url: "https://www.jairanisabspublicschool.in/",
  },
  {
    id: 6,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp20.webp",
    templateCode: "SPCSFB",
    recommendation: true,
    headerText: "Similar Design Used By School: St. Peter's Convent School",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp20.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp20-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp20-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(163 193 255), rgb(235 220 187))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(186 171 254), rgb(251 197 97))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(163 193 255), rgb(99 50 122))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp20-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp20-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp20-3.webp",
    ],
    url: "https://www.spcsfbd.ac.in",
  },
  {
    id: 7,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp4.webp",
    templateCode: "CCSD",
    recommendation: false,
    headerText:
      "Similar Design Used By School: Carmel Convent School Dharuhera",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp4.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp4-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp4-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(1 91 40), rgb(252 252 123))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(18 53 117), rgb(239 173 132))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(63 7 10), rgb(241 202 127))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp4-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp4-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp4-3.webp",
    ],
    url: "https://carmelconventschooldharuhera.com",
  },
  {
    id: 8,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp5.webp",
    templateCode: "FSOOLG",
    recommendation: false,
    headerText:
      "Similar Design Used By School: Franciscan Sisters of Our Lady of Graces",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp5.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp5-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp5-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(119 32 140), rgb(97 13 118))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(144 31 1), rgb(206 62 25))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(39 5 47), rgb(93 13 114))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp5-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp5-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp5-3.webp",
    ],
    url: "https://fslg.in",
  },
  {
    id: 9,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp6.webp",
    templateCode: "HCSN",
    recommendation: true,
    headerText: "Similar Design Used By School: Holy Cross School, Nautanwa",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp6.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp6-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp6-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(9 64 94), rgb(224 187 44))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(25 49 95), rgb(182 43 19))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(240 175 37), rgb(22 88 162))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp6-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp6-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp6-3.webp",
    ],
    url: "https://www.holycrossschoolnautanwa.in",
  },
  {
    id: 10,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp11.webp",
    templateCode: "ABCD",
    recommendation: false,
    headerText: "Similar Design Used By School: Mercy Memorial School, Kanpur",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp11-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp11-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(43 93 204), rgb(254 150 0))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(233 151 5), rgb(95 13 123))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(41 91 198), rgb(253 141 0))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp11-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp11-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp11-3.webp",
    ],
    url: "https://www.mercymemorialkanpur.in",
  },
  {
    id: 11,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp12.webp",
    templateCode: "NCSRD",
    recommendation: false,
    headerText: "Similar Design Used By School: Nirmala Convent School, Rajkot",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp12-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp12-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(124 174 224), rgb(164 20 145))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(72 130 144), rgb(218 172 61))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(126 202 172), rgb(154 69 213))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp12-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp12-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp12-3.webp",
    ],
    url: "https://www.nirmalaconventschool.org/",
  },
  {
    id: 12,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp13.webp",
    templateCode: "MDAM",
    recommendation: false,
    headerText: "Similar Design Used By School: Notre Dame Academy, Munger",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp13.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp13-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp13-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(25 73 152), rgb(255 176 21))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(0 100 196), rgb(165 42 70))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(0 103 199), rgb(12 117 77))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp13-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp13-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp13-3.webp",
    ],
    url: "https://www.ndmunger.com/",
  },
  {
    id: 13,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp14.webp",
    templateCode: "PCSDD",
    recommendation: false,
    headerText: "Similar Design Used By School: PCS Delhi",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp14.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp14-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp14-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(57 98 123), rgb(153 69 136))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(72 71 99), rgb(146 171 70))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(57 98 123), rgb(159 74 141))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp14-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp14-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp14-3.webp",
    ],
    url: "https://www.pcsdelhi.in",
  },
  {
    id: 14,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp15.webp",
    templateCode: "SJSMH",
    recommendation: false,
    headerText: "Similar Design Used By School: St Joseph Mandi, Haryana",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp15.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp15-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp15-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(13 90 129), rgb(255 179 254))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(185 75 60), rgb(225 158 31))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(109 62 160), rgb(186 69 124))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp15-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp15-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp15-3.webp",
    ],
    url: "https://www.stjosephpilar.com",
  },
  {
    id: 15,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp16.webp",
    templateCode: "SBBS",
    recommendation: false,
    headerText: "Similar Design Used By School: St. Basil School, Basti",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp16.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp16-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp16-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(0 92 159), rgb(251 190 37))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(101 73 233), rgb(248 187 34))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(249 110 206), rgb(255, 166, 0))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp16-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp16-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp16-3.webp",
    ],
    url: "https://stbasilbasti.online/",
  },
  {
    id: 16,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp17.webp",
    templateCode: "SJSG",
    recommendation: true,
    headerText: "Similar Design Used By School: St. Joseph's School Gorakhnath",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp17.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp17-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp17-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(102 178 201), rgb(255 225 113))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(52 93 122), rgb(245, 198, 42))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(140 216 236), rgb(245, 198, 42))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp17-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp17-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp17-3.webp",
    ],
    url: "https://www.sjsgorakhnath.org",
  },
  {
    id: 17,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp18.webp",
    templateCode: "SMCSST",
    recommendation: false,
    headerText:
      "Similar Design Used By School: St. Mary’s Convent Sr. Sec. School, Tigaon",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp18.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp18-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp18-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(19 55 89), rgb(244 155 1))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(63 79 141), rgb(243 255 157))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(65 31 140), rgb(164 58 150))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp18-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp18-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp18-3.webp",
    ],
    url: "https://stmarysfbd.edu.in",
  },
  {
    id: 18,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp19.webp",
    templateCode: "SMCSU",
    recommendation: false,
    headerText:
      "Similar Design Used By School: St. Mary's Convent Sr. Sec. School, Ujjain",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp19.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp19-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp19-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(30 49 151), rgb(195 131 34))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(233 113 173), rgb(65 112 198))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(50 77 210), rgb(202 140 41))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp19-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp19-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp19-3.webp",
    ],
    url: "https://www.stmarysujjain.online/",
  },
  {
    id: 19,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp21.webp",
    templateCode: "TPSB",
    recommendation: false,
    headerText:
      "Similar Design Used By School: Tagore Public School, Ballabhgarh",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp21.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp21-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp21-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(253 154 28), rgb(51 51 51))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(51 51 51), rgb(44 64 146))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(207 56 161), rgb(51 51 51))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp21-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp21-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp21-3.webp",
    ],
    url: "https://www.tagoreacademy.org.in",
  },
  {
    id: 20,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp2.webp",
    templateCode: "ABSB",
    recommendation: false,
    headerText: "Similar Design Used By School: Anand Bhavan School, Barabanki",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp2-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp2-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(29 34 122), rgb(255 204 2))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, #b74141, #f5c62a)",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(67 26 96), rgb(167 59 185))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp2-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp2-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp2-3.webp",
    ],
    url: "https://anandbhawanschool.com",
  },
  {
    id: 21,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp3.webp",
    templateCode: "ACGS",
    recommendation: false,
    headerText: "Similar Design Used By School: Awadh College",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp3.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp3-11.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp3-12.webp",
    ],
    colorOptions: [
      {
        className: "maroon-color",
        gradient: "linear-gradient(45deg, rgb(47 62 227), rgb(80 97 229))",
      },
      {
        className: "blue-color",
        gradient: "linear-gradient(45deg, rgb(62 168 156), rgb(255 145 49))",
      },
      {
        className: "green-color",
        gradient: "linear-gradient(45deg, rgb(16 26 137), rgb(253 148 0))",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp3-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp3-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp3-3.webp",
    ],
    url: "https://www.littleflowerschoolgkp.com",
  },
  {
    id: 22,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp24.webp",
    templateCode: "",
    recommendation: false,
    headerText: "Similar design used by school:",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp24.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp24-12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp24-13.webp",
    ],
    colorOptions: [
      {
        className: "Light_Blue+Dark_Blue",
        gradient: "linear-gradient(45deg, #536DFE, #304FFE)",
      },
      {
        className: "White+Blue",
        gradient: "linear-gradient(45deg, #FFFFFF, #00BFA5)",
      },
      {
        className: "White+Light_Blue",
        gradient: "linear-gradient(45deg, #FFFFFF, #536DFE)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp24-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp24-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp24-3.webp",
    ],
    url: "",
    variant: "short",
  },
  {
    id: 23,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp25.webp",
    templateCode: "SMNSB",
    recommendation: true,
    headerText: "Similar design used by school: SMNS Bokaro",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp25.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp25-12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp25-13.webp",
    ],
    colorOptions: [
      {
        className: "LEMON+BLUE",
        gradient: "linear-gradient(45deg, #FFEA00, #304FFE)",
      },
      {
        className: "PURPLE+BLUE",
        gradient: "linear-gradient(45deg, #FFFFFF, #304FFE)",
      },
      {
        className: "TEAL+YELLOW",
        gradient: "linear-gradient(45deg, #00BFA5, #536DFE)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp25-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp25-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp25-3.webp",
    ],
    url: "https://www.smnsbokaro.in/",
    variant: "short",
  },
  {
    id: 24,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp26.webp",
    templateCode: "",
    recommendation: false,
    headerText: "Similar design used by school",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp26.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp26-12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp26-13.webp",
    ],
    colorOptions: [
      {
        className: "LEMON+BLUE",
        gradient: "linear-gradient(45deg, #76F6FF, #79FF5E)",
      },
      {
        className: "PURPLE+BLUE",
        gradient: "linear-gradient(45deg, #FFEF76, #C7FF5E)",
      },
      {
        className: "TEAL+YELLOW",
        gradient: "linear-gradient(45deg, #3518D8, #A315D3)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp26-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp26-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp26-3.webp",
    ],
    url: "",
    variant: "short",
  },
  {
    id: 30,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp30.webp",
    templateCode: "",
    recommendation: false,
    headerText: "Similar design used by school",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp30.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp30-12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp30-13.webp",
    ],
    colorOptions: [
      {
        className: "Light-Blue+Green",
        gradient: "linear-gradient(45deg, #76F6FF, #79FF5E)",
      },
      {
        className: "Light-Yellow+Light-Green",
        gradient: "linear-gradient(45deg, #FFEF76, #C7FF5E)",
      },
      {
        className: "Purple+Pink",
        gradient: "linear-gradient(45deg, #3518D8, #A315D3)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp30-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp30-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp30-3.webp",
    ],
    url: "",
    variant: "short",
  },

  {
    id: 31,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp31.webp",
    templateCode: "",
    recommendation: false,
    headerText: "Similar design used by school",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp31.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp31-12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp31-13.webp",
    ],
    colorOptions: [
      {
        className: "Sky-Blue+Nav-Blue",
        gradient: "linear-gradient(45deg, #5BEBFF, #4964BD)",
      },
      {
        className: "Sea-Green+Orange",
        gradient: "linear-gradient(45deg, #5BFFC6, #FFCC25)",
      },
      {
        className: "Dark-Blue+Red",
        gradient: "linear-gradient(45deg, #2B6EAD, #FF433C)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp31-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp31-2.jgp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp31-3.webp",
    ],
    url: "",
    variant: "short",
  },

  {
    id: 32,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp32.webp",
    templateCode: "",
    recommendation: false,
    headerText: "Similar design used by school",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp32.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp32-12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp32-13.webp",
    ],
    colorOptions: [
      {
        className: "Red+Yellow",
        gradient: "linear-gradient(45deg, #FF5B5B, #FFDF77)",
      },
      {
        className: "Purple+Green",
        gradient: "linear-gradient(45deg, #605BFF, #ADFFD6",
      },
      {
        className: "Pink+Light-Green",
        gradient: "linear-gradient(45deg, #D353E6, #BDF37C)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp32-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp32-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp32-3.webp",
    ],
    url: "",
    variant: "short",
  },

  {
    id: 33,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp33.webp",
    templateCode: "",
    recommendation: false,
    headerText: "Similar design used by school",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp33.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp33-12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp33-13.webp",
    ],
    colorOptions: [
      {
        className: "Red+Yellow",
        gradient: "linear-gradient(45deg, #FF5B5B, #FFDF77)",
      },
      {
        className: "Purple+Green",
        gradient: "linear-gradient(45deg, #605BFF, #ADFFD6",
      },
      {
        className: "Pink+Light-Green",
        gradient: "linear-gradient(45deg, #D353E6, #BDF37C)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp33-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp33-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp33-3.webp",
    ],
    url: "",
    variant: "short",
  },

  {
    id: 34,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34.webp",
    templateCode: "DPSSLG",
    recommendation: false,
    headerText: "Similar design used by school",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-13.webp",
    ],
    colorOptions: [
      {
        className: "Blue+Green",
        gradient: "linear-gradient(45deg, #B1FFBC, #5569BB)",
      },
      {
        className: "Purple+Light-Blue",
        gradient: "linear-gradient(45deg, #9AC9FF, #5854D5)",
      },
      {
        className: "Teal+Light-Orange",
        gradient: "linear-gradient(45deg, #FFDB8F, #46A9A9)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-3.webp",
    ],
    url: "https://www.dpssiliguri.com/",
    variant: "short",
  },
  {
    id: 35,
    imgName:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34.webp",
    templateCode: "DPSFS",
    recommendation: false,
    headerText: "Similar design used by school",
    themeImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-12.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-13.webp",
    ],
    colorOptions: [
      {
        className: "Blue+Green",
        gradient: "linear-gradient(45deg, #B1FFBC, #5569BB)",
      },
      {
        className: "Purple+Light-Blue",
        gradient: "linear-gradient(45deg, #9AC9FF, #5854D5)",
      },
      {
        className: "Teal+Light-Orange",
        gradient: "linear-gradient(45deg, #FFDB8F, #46A9A9)",
      },
    ],
    deviceImages: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-1.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-2.webp",
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ENTAB/public/Images/temp34-3.webp",
    ],
    url: "https://www.dpsfulbarisiliguri.com/",
    variant: "short",
  },
];
